import classicHero from '../assets/themes/classic/hero.jpg';
import classicHeroMobile from '../assets/themes/classic/hero-mobile.jpg';
import classicInstruments from '../assets/themes/classic/instruments.jpg';
import classicStage from '../assets/themes/classic/stage.jpg';

import playfulHero from '../assets/themes/playful/hero.jpg';
import playfulHeroMobile from '../assets/themes/playful/hero-mobile.jpg';
import playfulInstruments from '../assets/themes/playful/instruments.jpg';
import playfulStage from '../assets/themes/playful/stage.jpg';

import faithHero from '../assets/themes/faith/hero.jpg';
import faithHeroMobile from '../assets/themes/faith/hero-mobile.jpg';
import faithInstruments from '../assets/themes/faith/instruments.jpg';
import faithStage from '../assets/themes/faith/stage.jpg';

import bluesHero from '../assets/themes/blues/hero.jpg';
import bluesHeroMobile from '../assets/themes/blues/hero-mobile.jpg';
import bluesInstruments from '../assets/themes/blues/instruments.jpg';
import bluesStage from '../assets/themes/blues/stage.jpg';

import brightHero from '../assets/themes/bright/hero.jpg';
import brightHeroMobile from '../assets/themes/bright/hero-mobile.jpg';
import brightInstruments from '../assets/themes/bright/instruments.jpg';
import brightStage from '../assets/themes/bright/stage.jpg';

export const THEME_STORAGE_KEY = 'missnatalie-art-theme';

export type ThemeId = 'classic' | 'playful' | 'faith' | 'blues' | 'bright';

export type ThemeArt = {
  id: ThemeId;
  label: string;
  tagline: string;
  description: string;
  hero: string;
  heroMobile: string;
  instruments: string;
  stage: string;
};

export const THEMES: ThemeArt[] = [
  {
    id: 'classic',
    label: 'Classic studio',
    tagline: 'Current live look',
    description: 'Warm cinematic studio with piano, guitar, and colorful sound ribbons — the original full-screen hero.',
    hero: classicHero,
    heroMobile: classicHeroMobile,
    instruments: classicInstruments,
    stage: classicStage,
  },
  {
    id: 'playful',
    label: 'Playful',
    tagline: 'Kids energy · confetti notes',
    description: 'Bright, whimsical illustration for younger students — balloons, crayons, and joyful noise.',
    hero: playfulHero,
    heroMobile: playfulHeroMobile,
    instruments: playfulInstruments,
    stage: playfulStage,
  },
  {
    id: 'faith',
    label: 'Gentle light',
    tagline: 'Soft spiritual warmth',
    description: 'Chapel-window light, peaceful piano room, and sanctuary-stage calm — faith-friendly without heavy branding.',
    hero: faithHero,
    heroMobile: faithHeroMobile,
    instruments: faithInstruments,
    stage: faithStage,
  },
  {
    id: 'blues',
    label: 'Blues palette',
    tagline: 'Indigo · sapphire · night studio',
    description: 'Cool blue night-studio mood — sophisticated and artistic for recitals and stage stories.',
    hero: bluesHero,
    heroMobile: bluesHeroMobile,
    instruments: bluesInstruments,
    stage: bluesStage,
  },
  {
    id: 'bright',
    label: 'Simple & bright',
    tagline: 'Airy · minimal · daylight',
    description: 'Clean white space, soft daylight, spare piano and guitar — simple, bright, uncluttered.',
    hero: brightHero,
    heroMobile: brightHeroMobile,
    instruments: brightInstruments,
    stage: brightStage,
  },
];

export function getTheme(id: string | null | undefined): ThemeArt {
  return THEMES.find((t) => t.id === id) ?? THEMES[0];
}

export function readStoredThemeId(): ThemeId {
  if (typeof window === 'undefined') return 'classic';
  try {
    const v = localStorage.getItem(THEME_STORAGE_KEY);
    if (v && THEMES.some((t) => t.id === v)) return v as ThemeId;
  } catch {
    /* ignore */
  }
  return 'classic';
}

export function writeStoredThemeId(id: ThemeId): void {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, id);
    window.dispatchEvent(new CustomEvent('missnatalie-theme', { detail: id }));
  } catch {
    /* ignore */
  }
}
